export default __webpack_public_path__ + "b0751ec.png";